const MyTransactions: React.FC = () => {
  return <div>My Transactions</div>
}

export default MyTransactions
